Plugins.ExamplePlugin = class extends React.Component {
  render() {
    return <div>Foo React Bar</div>
  }
}